<script setup lang="ts">
const props = withDefaults(
  defineProps<{ src: string; srcPlaceholder?: string; alt?: string }>(),
  {
    srcPlaceholder:
      "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
    alt: "",
  }
);
const emit = defineEmits(["load", "error", "intersect"]);

let observer: IntersectionObserver;
const intersectionOptions = {};
const root = ref<HTMLImageElement>();
const state = reactive<{
  intersected: boolean;
  loaded: boolean;
}>({
  intersected: false,
  loaded: false,
});

const srcImage = computed(() =>
  state.intersected && props.src ? props.src : props.srcPlaceholder
);

const load = () => {
  if (root.value && root.value.getAttribute("src") !== props.srcPlaceholder) {
    state.loaded = true;
    emit("load", root.value);
  }
};

const error = () => emit("error", root.value);

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    const image = entries[0];
    if (image.isIntersecting) {
      state.intersected = true;
      observer.disconnect();
      emit("intersect");
    }
  }, intersectionOptions);

  if (root.value) {
    observer.observe(root.value);
  }
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<template>
  <img
    ref="root"
    :src="srcImage"
    :class="['lazy-image', { 'lazy-image-loaded': state.loaded }]"
    :alt="alt"
    @load="load"
    @error="error"
  />
</template>

<style scoped>
.v-lazy-image {
  opacity: 0;
  transition: opacity 2s;
}

.v-lazy-image-loaded {
  opacity: 1;
}
</style>
